<template>
    <div v-if="loadRelatedNews" id="relatedNews" >
        <dl>
            <dt>
                <span class="list-title">{{$t('mayLike')}}</span>
            </dt>

            <dd v-for="(news,i) in relatedNews" class="detail" :key="i">
                <a :href="`/news/${getUrlTitle(subtitChoose)}/${getUrlTitle(news.title)}/${news.aid}}`">
                    <div
                      v-if="news.type === 'video'"
                      class="detail-img-video"
                      :style="{backgroundImage:'url(https://allfootball-static.dongqiudi.com/web-new/static/api/images/video_play.png),url(' + news.thumb + ')' }"
                    >
                    </div>

                    <div v-else class="detail-img" :style="{backgroundImage:'url('+ news.thumb +')' }" ></div>
                    <p v-html="news.title" class="detail-title"></p>
                    <span v-html="news.time" class="detail-time"></span>

                    <span v-if="news.comments_total != 0" class="detail-comments" v-html="news.comments_total"></span>
                </a>
            </dd>
        </dl>
    </div>
</template>
<script>
    import Vue from 'vue';
    import axios from 'axios';

    export default {
        name: 'relatedNews',
        props: ['articleId'],
        data () {
            return {
                relatedNews: [],
                article_id: this.articleId,
                loadRelatedNews: false
            };
        },
        computed: {
            subtitChoose () {
                if (this.$route.params.subtitle) {
                    return this.$route.params.subtitle;
                }
                if (this.$store.state.navStore && this.$store.state.navStore.subtitChoose) {
                    return this.$store.state.navStore.subtitChoose;
                }
                return 'Headline';
            }
        },
        created: function () {
            let type = this.$route.query.type;
            if (type === 'share') {
                this.loadRelatedNews = false;
            } else {
                this.init();
            }
        },
        methods: {
            init () {
                axios.get(global.apiDomain + '/m/v2/article/relate/' + this.article_id + '?plat=m&language=id-id').then((response) => {

                    let relatedNews = response.data.relate;

                    if (relatedNews && relatedNews.length > 0) {
                        this.loadRelatedNews = true;
                    } else {
                        return;
                    }
                    for (let i = 0; i < relatedNews.length; i++) {
                        Vue.set(this.relatedNews, i, relatedNews[i]);
                    }
                }, (error) => {});
            },

            newsClick (newsId) {
                location.href = '/news?id=' + newsId;
            }
        }
    };
</script>

<style>
    #relatedNews {
        padding-bottom: 38px;
    }

    #relatedNews .list-title {
        display: inline-block;
        height: 20px;
        font-size: 16px;
        font-weight: 600;
        line-height: 20px;
        color: #2d2f32;
    }

    #relatedNews .list-title:before {
        display: inline-block;
        height: 24px;
        width: 3px;
        margin-right: 12px;
        vertical-align: middle;
        content: "";
        background-color: #16b13a;
    }

    #relatedNews .detail {
        margin: 0 15px;
        padding: 12px 0;
        border-bottom: 1px solid #eff1f4;
        position: relative;
    }

    #relatedNews .detail:nth-of-type(1) a {
        margin: 14px 0 0;
    }

    #relatedNews .detail a {
        display: block;
        padding-left: 85px;
        position: relative;
        min-height: 43px;
        padding-bottom: 12px;
    }

    #relatedNews .detail-img,
    #relatedNews .detail-img-video {
        background-color: #e9e9e9;
        width: 75px;
        height: 55px;
        position: absolute;
        left: 0;
        background-repeat: no-repeat;
    }

    #relatedNews .detail-img {
        background-position: center center;
        background-size: 100% auto;
    }

    #relatedNews .detail-img-video {
        background-color: #e9e9e9;
        background-position: center center, center center;
        background-size: 24px auto, 100% auto;

    }

    #relatedNews .detail-title {
        line-height: 19px;
        margin: 0;
        color: #2d2f32;
        font-size: 15px;
        position: relative;
        bottom: 2px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        min-height: 38px;
        max-height: 58px;
        -webkit-line-clamp: 3;
        -moz-line-clamp: 3;
        -o-line-clamp: 3;
        -ms-line-clamp: 3;
        line-clamp: 3;

        -webkit-box-orient: vertical;
        -moz-box-orient: vertical;
        -o-box-orient: vertical;
        -ms-box-orient: vertical;
        box-orient: vertical;
    }

    #relatedNews span {
        color: #8c9399;
        font-size: 11px;
    }

    #relatedNews .detail-time {
        float: left;
        line-height: 21px;
    }

    #relatedNews .detail-comments {
        display: block;
        text-align: right;
        position: absolute;
        right: 0;
        bottom: -1px;
        height: 14px;
    }

    #relatedNews .detail-comments:after {
        display: inline-block;
        background: url("../assets/i_comment.png") center center no-repeat;
        background-size: 13px auto;
        content: "";
        width: 13px;
        margin-left: 4px;
        position: relative;
        top: 3px;
        height: 14px;
    }
</style>



// WEBPACK FOOTER //
// relatedNews.vue?3d0ec5bc